export default "__VITE_ASSET__DRUhHG7H__"